import { useI18n } from 'core/hooks/useI18n';

import { StyledLink } from './Error.styles';

export const ReturnHome = () => {
  const { l10n } = useI18n('app/components', 'errors');
  return <StyledLink href="/">{l10n('returnHome')}</StyledLink>;
};
